import React from 'react';
import queryString from 'query-string';
import '../../../../../scss/PublicView/Pages/Home.scss';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config'
import { Input } from '@progress/kendo-react-inputs';

export default class ChangePassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            passwordConfirm: '',
            resetToken: '',
            email: '',
            success: false,
            sent: false,
            msg: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.getUserEmailAndTokenFromParams();
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
        // console.log('state', this.state)
    }

    getUserEmailAndTokenFromParams() {
        const parsed = queryString.parse(this.props.location.search);

        let email = parsed.email;

        if (email.includes(' ')) {
            email = email.trim().split(' ').join('+');
        }

        this.setState({
            id: parsed.id,
            email: email,
            resetToken: parsed.token
        })
    }

    handleSubmit(event) {
        this.setState({
            success: '',
            msg: ''
        });
        //console.log(this.state)

        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json;charset=UTF-8'
            }
        };

        //console.log('here');

        axios.post(`${ROOT_API_URL}/account/resetpassword`,
            {
                Id: this.state.id,
                Email: this.state.email,
                Password: this.state.password,
                ResetToken: this.state.resetToken
            },
            config).then(response => {
                //if (response && response.data && !response.data.isSuccess) {
                //    this.setState({
                //        success: response.data.isSuccess,
                //        sent: true
                //    });
                //} else {
                //    this.setState({
                //        success: response.data.isSuccess,
                //        sent: true
                //    });
                //}
                this.setState({
                    success: response.data.isSuccess,
                    msg: response.data.message,
                    sent: true
                });
            }, error => {
                this.setState({
                    success: false,
                    sent: false
                });
            });
        event.preventDefault();
    }


    render() {
        const confirmPasswordValidationMessage = "Passwords do not match!";
        const passwordValidation = `Passwords must be between 6 and 18 characters, 
                                    have at least one non-alphanumeric character, 
                                    one digit ('0'-'9'), 
                                    one uppercase ('A'-'Z'), and 
                                    one lowercase ('a'-'z').`;
        const passwordRegex = `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$_^+=!*()@%&]).{6,}$`;

        return (
            <div className="homeContainer">
                <div className="homeWelcomeContent reset-password">
                    <div className="container-fluid">
                        <h1>
                            Change your password
                        </h1>
                        <div>
                            {(this.state.success === false) ? <p>Choose and confirm the new password for <span className='email'>{this.state.email}</span>.</p> : null}
                        </div>
                        <div >
                        {(this.state.success === false) ?
                            <form className="menuLogin createAccountForm" onSubmit={this.handleSubmit}>
                                <div className="labelField form-group">
                                    <label className="col-12">Password</label>
                                    <Input
                                        type="password"
                                        name="password"
                                        id="registerPassword"
                                        className="form-control"
                                        value={this.state.password}
                                        required={true}
                                        minLength={6}
                                        maxLength={18}
                                        pattern={passwordRegex}
                                        placeholder="Enter Password"
                                        onChange={this.handleInputChange}
                                        validationMessage={passwordValidation} />
                                </div>
                                <div className="labelField form-group">
                                    <label className="col-12">Confirm Password</label>
                                    <Input
                                        type="password"
                                        required={true}
                                        name="passwordConfirm"
                                        className="form-control"
                                        valid={this.state.password && this.state.password === this.state.passwordConfirm}
                                        validationMessage={confirmPasswordValidationMessage}
                                        id="confirmRegisterPassword"
                                        value={this.state.passwordConfirm}
                                        placeholder="Confirm Password"
                                        onChange={this.handleInputChange} />
                                </div>
                                <div className="homeBtnContainer form-group">
                                    <div className="v-space"></div>
                                    <button className='btnPrimary btn-block labelFieldSize' type="submit">Submit</button>
                                </div>

                            </form> : null }
                        </div>
                        <p> {(this.state.success === true) ? `Password successfully changed. An email has been sent to the associated account.` : null }</p>
                        <p> {(this.state.success === false && this.state.sent === true) ? (this.state.msg ? this.state.msg : `Password change unsuccessful. Please try again.`) : null }</p>

                    </div>
                </div>
            </div>
        )
    }
}

//export default withRouter(RegisterConfirmation)